import { useCollection } from "api/hooks/useCollection";
import { ChampionshipDriver } from "api/model/Championship/ChampionshipDriver";
import { Collections } from "api/model";

export const useChampionshipDrivers = (championshipId: string) => {
    return useCollection<ChampionshipDriver[]>(
        {
            collection: Collections.CHAMPIONSHIP_DRIVERS,
            where: ["championshipId", "==", championshipId || "-1"],
            storeAs: `drivers_${championshipId || "-1"}`,
        },
        true
    );
};